import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CommunityCreatorResourcesRoute extends DiscourseRoute {
  @service communityNavigation;

  queryParams = {
    type: { refreshModel: true },
    sort: { refreshModel: true },
    page: { refreshModel: true },
  };

  async beforeModel(transition) {
    const tree = await this.communityNavigation.load();
    if (!tree.secondary.creator) {
      transition.abort();
      const error = new Error("Creator resources not found");
      error.status = 404;
      throw error;
    }
  }

  model({ type = "all", sort = "latest", page = 0 }) {
    return { type, sort, page };
  }

  titleToken() {
    return i18n("community_navigation.resource_sharing");
  }
}
